import React from 'react';
import { Container, Typography, useMediaQuery } from '@mui/material';
import NoAssetFound from '../../assets/images/no-asset.svg';

const NotApproved = () => {
  const isSmallScreen = useMediaQuery('(max-width: 600px)');
  return (
    <Container
      maxWidth="xl"
      style={{
        display: 'flex',
        justifyContent: 'center',
        flexDirection: 'column',
        alignItems: 'center',
        minHeight: '80vh',
        width: !isSmallScreen ? '480px' : '100%',
        textAlign: 'center',
      }}
    >
      <div>
        <img src={NoAssetFound} alt="Not Approved" />
      </div>
      <Typography variant="h4">Under Review</Typography>
      <Typography color="grey" marginTop={2}>
        Thank you for signing up to our platform.
      </Typography>

      <Typography color="grey" marginTop={2}>
        We appreciate your time in registering your details. We will email you
        soon to confirm whether your application has been approved. If you have
        any questions, please reach out to{' '}
        <a href="mailto:contact@bluesana.com.au">contact@bluesana.com.au</a>
      </Typography>
    </Container>
  );
};

export default NotApproved;
